import LoyaltyOnboardingDesktop from "components/organisms/LoyaltyOnboardingDesktop";
import { useLoyaltyStore } from "stores/loyalty";
import { useCallback, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { GET_POPUP_TYPES } from "../../constants/popupConfig";

export const LoyaltyOnboardingDesktopContainer = () => {
  const { isCustomBreakpointBigger } = useBreakpoint(440);
  const navigate = useNavigate();
  const location = useLocation();
  const refOnboardingIsWatch = useRef<boolean>(
    localStorage.getItem("onboardingIsWatch")
      ? JSON.parse(localStorage.getItem("onboardingIsWatch")!)
      : false,
  );
  const onboardingIsOpen = useLoyaltyStore((state) => state.isOpenOnboarding);
  const handleOpenOnboarding = useLoyaltyStore(
    (state) => state.setIsOpenOnboarding,
  );

  const handleCloseOnboarding = () => {
    handleOpenOnboarding(false);
    localStorage.setItem("onboardingIsWatch", "true");
  };

  const handleEndOnboard = () => {
    handleOpenOnboarding(false);
    localStorage.setItem("onboardingIsWatch", "true");
  };

  const handleStartOnboarding = useCallback(() => {
    if (!refOnboardingIsWatch.current && isCustomBreakpointBigger) {
      handleOpenOnboarding(true);
    } else if (!refOnboardingIsWatch.current && !isCustomBreakpointBigger) {
      handleOpenOnboarding(false);
      navigate(
        `${location.pathname}?popup=${GET_POPUP_TYPES.popup.loyaltyOnboarding}`,
        { replace: true },
      );
    }
  }, [
    handleOpenOnboarding,
    isCustomBreakpointBigger,
    location.pathname,
    navigate,
  ]);

  useEffect(() => {
    handleStartOnboarding();
  }, [handleStartOnboarding]);

  useEffect(() => {
    return () => {
      handleOpenOnboarding(false);
    };
  }, [handleOpenOnboarding]);

  return (
    <LoyaltyOnboardingDesktop
      isProgress={onboardingIsOpen}
      onEndWatchOnboard={handleEndOnboard}
      onCloseOnboard={handleCloseOnboarding}
    />
  );
};
